<script lang="ts">
    export let height = "h-6";
    export let width = "w-6";
    export let strokeColor = "stroke-white";
    export let fillColor = "fill-white";
    export let hover = "group-hover/btn-emoji:fill-white";
    export let classList = "aspect-ratio transition-all";
</script>

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="{height} {width} {strokeColor} {fillColor} {classList} {hover} icon icon-tabler icons-tabler-filled icon-tabler-man"
>
    <g clip-path="url(#clip0_827_10)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4118 11.5L20.4118 17C21.4122 14.5 20.4804 10.368 18.8213 8.68483C17.1621 7.00167 14.775 6.0348 12.4118 6C10.0486 6.0348 7.66144 7.00202 6.00229 8.68517C4.34314 10.3683 3.41133 14.5003 4.41178 17.0003L6.41178 11.5003L6.91178 14.5003L8.41178 12.5003L9.41178 14.0003L10.4118 11.5003C10.4118 11.5003 11.9118 12.5 12.4118 12.5C12.9118 12.5 14.4118 11.5 14.4118 11.5L15.4118 14L16.4118 12.5L17.9118 14.5L18.4118 11.5Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_827_10">
            <rect width="24" height="24" fill="currentColor" />
        </clipPath>
    </defs>
</svg>
